module.exports = __webpack_public_path__ + "img/code-vue-lg.baff0d55.webp";